import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Typography from '@material-ui/core/Typography';

import TextLink from 'src/components/TextLink';
import useStyles from './useStyles';

const DefaultOptions = ({
  className,
  classes,
  options,
  onSelect,
  disabled,
}) => {
  const styles = useStyles({ classes });

  return (
    <div className={cx(styles.root, className)} data-testid="DefaultOptions">
      <Typography className={styles.title}>
        We couldn’t find anything that matched your search.
        <br />
        You can start with one of the following:
      </Typography>

      <div className={styles.options}>
        {options.map((option) => (
          <TextLink
            className={styles.option}
            key={option.id}
            onClick={() => onSelect(option)}
            disabled={disabled}
            data-testid={`DefaultOptions__${option.name}Link`}
          >
            {option.name}
          </TextLink>
        ))}
      </div>
    </div>
  );
};

DefaultOptions.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

DefaultOptions.defaultProps = {
  className: null,
  classes: null,
  disabled: false,
};

export default React.memo(DefaultOptions);
